import { render, staticRenderFns } from "./vipssStudentDetail.vue?vue&type=template&id=6e13339a&scoped=true&"
import script from "./vipssStudentDetail.vue?vue&type=script&lang=js&"
export * from "./vipssStudentDetail.vue?vue&type=script&lang=js&"
import style0 from "./vipssStudentDetail.vue?vue&type=style&index=0&id=6e13339a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e13339a",
  null
  
)

export default component.exports